import { withAuthenticationRequired, useAuth0 } from '@auth0/auth0-react'
import React from 'react'

export const AuthenticationGuard = ({ component }) => {
	useAuth0()

	const Component = withAuthenticationRequired(component, {
		onRedirecting: () => {
			return <div className='page-layout'></div>
		},
	})

	return <Component />
}
